import GenericErrorTurnback from './GenericErrorTurnback'

const RootError = () => {
  return (
    <GenericErrorTurnback
      mangoTurnBack={{
        testId: 'system-error',
        title: 'System Error',
        variant: 'generic-error',
        description: [
          <p key="1">Something went wrong on our end</p>,
          <p key="2">Try the following to resolve the issue</p>,
          <ul key="3">
            <li>Refresh the page and try again</li>
            <li>Contact our customer support</li>
          </ul>,
        ],
      }}
      mangoButton={{
        key: 'refresh-button',
        variant: 'primary',
        testId: 'refresh-button',
        actionType: 'refresh',
        buttonText: 'Refresh',
      }}
      mangoButtonLink={{
        variant: 'tertiary',
        key: 'help-centre-button',
        testId: 'help-centre-button',
        href: 'https://help.humanforce.com/hc/en-au/articles/360029504211-Welcome-to-the-Humanforce-Help-Portal',
        target: '_blank',
        text: 'Help Centre',
      }}
    />
  )
}

export default RootError
